export default {"src":"/_next/static/media/video-red-icon.1b8fc69a.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};